export default {
  suites: {
    video: "/videos/suites.mp4",
    tags: ["Entrega estimada","Agosto 2027", "1, 2 y 3", "En construcción", "Amenábar 892, CABA"],
    brochure: "/dowloads/03 Voir Suites.pdf",
    sidetext: [
      {
        title: "Creado para vos",
        body: "Más que un espacio residencial, VOIR Suites es una experiencia pensada para quienes buscan dinamismo, libertad y confort en un solo lugar. Diseñado con arquitectura contemporánea y materiales de primer nivel, cada rincón de este proyecto redefine el hogar urbano.",
        url: "/pics/suites/Hall Entrada.webp",
      },
      {
        title: "",
        body: "Voir Suites es un desarrollo de 23 unidades modernas y luminosas de uno, dos y tres ambientes. Disfrutá de un lugar que integra descanso, trabajo y ocio en perfecta armonía. Desde un coworking y laundry, hasta una terraza equipada con jacuzzi y parrilla, VOIR Suites ofrece espacios para disfrutar al máximo cada momento del día.",
        url: "/pics/suites/Terraza.webp",
      },
      {
        title: "Alquiler Temporario Inteligente",
        body: "VOIR Suites incorpora tecnología de acceso remoto mediante claves digitales, asegurando comodidad y seguridad para quienes eligen la flexibilidad del alquiler temporario. Bienvenidos a una nueva forma de vivir en Colegiales. Bienvenidos a VOIR Suites.",
        url: "/pics/suites/Edificio Atardecer.webp",
      },
    ],
    carousel: [
      "/pics/suites/Local por Fuera.webp",
      "/pics/suites/Hall Entrada.webp",
      "/pics/suites/3 Amb.webp",
      "/pics/suites/Dormitorio.webp",
      "/pics/suites/Monoambiente.webp",
      //"/pics/suites/Baño.webp",
      "/pics/suites/Sum - Subsuelo.webp",
      "/pics/suites/Terraza.webp",
      "/pics/suites/Edificio Dia.webp",
      "/pics/suites/Edificio Atardecer.webp",
      // "/pics/suites/3 amb Balcon.webp",
    ],
    map: {
      map: "/pics/suites/map.webp",
      link: "https://www.google.com.ar/maps/place/Amen%C3%A1bar+892,+C1426AJN+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.571546,-58.4507485,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb5c479a147dd:0x6e82f76f8b547b37!8m2!3d-34.571546!4d-58.4481736!16s%2Fg%2F11c4tschy7?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
      location: "Amenábar 892, CABA",
      title: "Una nueva forma de vivir Colegiales",
      coords: [
        -34.57142229240189,
        -58.44815214594486,
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d797.9403901849287!2d-58.448640216378855!3d-34.57159998717503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb5c479a147dd%3A0x6e82f76f8b547b37!2sAmen%C3%A1bar%20892%2C%20C1426AJN%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires%2C%20Argentina!5e0!3m2!1ses-419!2sbo!4v1751672725831!5m2!1ses-419!2sbo"
      ],
      body: "Voir Suites te invita a vivir en el equilibrio perfecto entre la ciudad y la tranquilidad. La comodidad y el bienestar se encuentran en cada detalle, ofreciéndote un estilo de vida que combina lo mejor de ambos mundos. Colegiales te recibe con una oferta gastronómica que va desde sus propios rincones secretos hasta los circuitos de Palermo Hollywood y Las Cañitas, a sólo unos pasos. Y gracias a su ubicación estratégica, Voir Suites conecta con toda la ciudad: estaciones de metrobus, tren y subte están a solo 4 cuadras, poniendo todo Buenos Aires a tu alcance. <br/><br/><b>En Voir Suites, no solo encontrás un hogar, sino un espacio pensado para vivir mejor.</b>"
    },
    environment: {
      Monoambiente: {
        "3D": "/pics/suites/3D/Monoambiente.webp",
        "2D": "/pics/suites/2D/Monoambiente.webp",
        surface: "35,39 m2",
        environments: 1,
        bathrooms: 1,
        rooms: 1,
      },
      "2 Ambientes": {
        "3D": "/pics/suites/3D/2 Ambientes.webp",
        "2D": "/pics/suites/2D/2 Ambientes.webp",
        surface: "42,09 m2",
        environments: 2,
        bathrooms: 1,
        rooms: 1,
      },
      "3 Ambientes": {
        "3D": "/pics/suites/3D/3 Ambientes.webp",
        "2D": "/pics/suites/2D/3 Ambientes.webp",
        surface: "63,26 m2",
        environments: 3,
        bathrooms: 1,
        toilets: 1,
        rooms: 1,
      },
      "3 Ambientes con Terraza": {
        "3D": "/pics/suites/3D/3 Ambientes con Terraza.webp",
        "2D": "/pics/suites/2D/3 Ambientes con Terraza.webp",
        surface: "123,71 m2",
        environments: 3,
        bathrooms: 2,
        toilets: 1,
        rooms: 2,
      },
    },
  },
  amenabar: {
    video: "/videos/amenabar.mp4",
    tags: ["Última unidad disponible", " ", "1, 2, 3 y 4", "Finalizado", "Amenábar 2913, CABA"],
    brochure: "/dowloads/BROCHURE_VOIR_AMENABAR.pdf",
    sidetext: [
      {
        title: "El nuevo Life-Style",
        body: "Voir Amenábar combina el equilibrio y la elegancia en una semi-torre moderna de 16 pisos que redefine el estilo de vida en Belgrano. Este proyecto es la fusión perfecta entre la calidez de un hogar y la seguridad de un edificio de alta gama, diseñado para aprovechar la luz natural y brindar un entorno armonioso.",
        url: "/pics/amenabar/IMG_7868.webp",
      },
      {
        title: "",
        body: `Cada espacio esta pensado para disfrutar, donde el diseño y el entorno se complementan en perfecta sintonía. La propuesta de Voir Amenábar incluye un conjunto de servicios y espacios de esparcimiento, diseñados para potenciar el confort de sus residentes:
        <br/><br/>
        <ul>
            <li>Gimnasio</li>
            <li>Pileta y Solarium</li>
            <li>SUM, parrilla y terraza</li>
            <li>Laundry</li>
            <li>Bauleras y cocheras cubiertas</li>
        </ul>`,
        url: "/pics/amenabar/Pileta.webp",
      },
      {
        title: "Viví Voir Amenábar",
        body: "Un nuevo estándar de vida urbana en Belgrano, donde el confort y la calidad de vida están siempre a la altura.",
        url: "/pics/amenabar/Frente.webp",
      },
    ],
    carousel: [
      "/pics/amenabar/Frente.webp",
      "/pics/amenabar/IMG_9511.webp",
      "/pics/amenabar/IMG_9440.webp",
      "/pics/amenabar/IMG_9522.webp",
      "/pics/amenabar/Pileta2.webp",
      "/pics/amenabar/Pileta.webp",
      "/pics/amenabar/Terraza2.webp",
      "/pics/amenabar/Parrilla.webp",
      "/pics/amenabar/Terraza.webp",
      "/pics/amenabar/Gym.webp",
    ],
    map: {
      map: "/pics/amenabar/map.webp",
      link: "https://www.google.com.ar/maps/place/Amen%C3%A1bar+2913,+C1429+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.5562002,-58.4668943,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb68221d35fa5:0x33a4971fe1937203!8m2!3d-34.5562002!4d-58.4643194!16s%2Fg%2F11h0t1wbwl?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
      title: "Encontrá tu hogar! Belgrano",
      location: "Amenábar 2913, CABA",
      body: "Amenábar se sitúa en el centro de Belgrano, uno de los barrios más dinámicos y seguros de Buenos Aires. Su ubicación estratégica ofrece rápido acceso a Av. Cabildo, Av. Congreso y los principales medios de transporte público, como la línea D de subte y el Metrobús. Se encuentra a solo minutos de centros médicos, prestigiosas instituciones educativas, comercios, clubes y una variada oferta gastronómica. Belgrano también brinda amplios espacios verdes para disfrutar al aire libre, convirtiéndolo en el entorno perfecto para un estilo de vida equilibrado. <br/><br/><b>Una ubicación que lo tiene todo: Conectividad, Seguridad y Confort</b>",
      coords: [-34.5559969458807, -58.464287217109636, "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3285.903569077359!2d-58.466867488826196!3d-34.55599687285869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDMzJzIxLjYiUyA1OMKwMjcnNTEuNCJX!5e0!3m2!1ses-419!2sar!4v1743687087913!5m2!1ses-419!2sar"], 
    },
    environment: {
      "Duplex Penthouse": {
        UP: "/pics/amenabar/UP/Duplex Penthouse.png",
        DOWN: "/pics/amenabar/DOWN/Duplex Penthouse.png",
        surface: "80 m2",
        environments: 3,
        bathrooms: 2,
        rooms: 2,
      },
    },
  },
  palpa: {
    video: "/videos/palpa.mp4",
    tags: ["Vendido", "", "1, 2 y 3", "Finalizado", "Palpa 2634, CABA"],
    brochure: "/dowloads/Voir Palpa Carpeta NEW_V2.pdf",
    sidetext: [
      {
        title: "Diseño de Vanguardia",
        body: "Voir Palpa redefine la vida en Colegiales, pensado para quienes valoran un hogar que se adapta a cada momento. Este proyecto integra descanso, trabajo y ocio en espacios modernos, diseñados para aprovechar la luz natural y ofrecer una experiencia de vida cómoda y flexible.",
        url: "/pics/palpa/VR_IRIVAS_PALPA_VISTA9_PARRILLA_A03.webp",
      },
      {
        title: "",
        body: "Con arquitectura contemporánea y acabados de alta calidad, Voir Palpa tiene 25 unidades modernas que ofrecen un entorno pensado para el bienestar y la inspiración. Cada detalle refleja el compromiso con el confort y la funcionalidad, en una ubicación que te conecta con todo lo que necesitas para vivir plenamente.",
        url: "/pics/palpa/IMG_9905.webp",
      },
      {
        title: "Viví Voir Palpa",
        body: "Ubicado en el corazón de Colegiales, Voir Palpa es más que un hogar: es un lugar donde el diseño y la ciudad se encuentran para ofrecerte un estilo de vida activo, conectado y completo.",
        url: "/pics/palpa/VR_IRIVAS_PALPA_VISTA5_DEPTO FRENTE APAISADO 207_A03.webp",
      },
    ],
    carousel: [
      "/pics/palpa/IMG_0082.webp",
      "/pics/palpa/IMG_0056.webp",
      "/pics/palpa/IMG_9956.webp",
      "/pics/palpa/IMG_0027.webp",
      "/pics/palpa/IMG_0021.webp",
      "/pics/palpa/IMG_9905.webp",
      "/pics/palpa/IMG_9981.webp",
      "/pics/palpa/IMG_9918.webp",
      //"/pics/palpa/VR_IRIVAS_PALPA_VISTA7_BAÑO_A03.webp",
      "/pics/palpa/IMG_0077.webp",
      "/pics/palpa/IMG_0073.webp",
      "/pics/palpa/Foto Pileta Dic. 2023.webp",
    ],
    map: {
      map: "/pics/palpa/map.webp",
      link: "https://www.google.com.ar/maps/place/Palpa+2634,+C1426DOH+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.5715145,-58.4508239,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb5c4791132cd:0x768909390f619cb2!8m2!3d-34.5715145!4d-58.448249!16s%2Fg%2F11hzxqbpvp?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
      title: "Colegiales<br/> se renueva con VOIR PALPA",
      location: "Palpa 2634, CABA",
      body: "Con excelente conectividad, a solo cuatro cuadras tenés acceso al metrobús, subte y tren, lo que te permitirá desplazarte cómodamente por toda Buenos Aires.<br /><br />Desde Voir Palpa vas a disfrutar de una amplia variedad de opciones gastronómicas y culturales a minutos de distancia: desde los “rincones” de Colegiales hasta los reconocidos circuitos de Palermo Hollywood y Las Cañitas.<br /><br />VOIR Palpa: Diseño, confort y conexión en uno de los barrios más atractivos de la ciudad.",
      coords: [-34.57140846102497, -58.44825973245216, "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3285.2947223603487!2d-58.45083998882548!3d-34.57140847285312!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDM0JzE3LjEiUyA1OMKwMjYnNTMuNyJX!5e0!3m2!1ses-419!2sar!4v1743687151805!5m2!1ses-419!2sar"],
    
    },
    environment: {
      "Local Comercial": {
        "2D": "/pics/palpa/2D/Local Comercial.png",
        surface: "82,48 m2",
        environments: 1,
        bathrooms: 1,
        kitchens: 1,
      },
    },
  },
  cespedes: {
    video: "/videos/cespedes.mp4",
    tags: ["Entrega estimada", "2028", "1, 2 y 3", "Etapa de Inicio de Obra", "Céspedes 2518, CABA"],
    brochure: "/dowloads/01 Live Voir Céspedes.pdf",
    sidetext: [
      {
        title: "LIVE VOIR Céspedes",
        body: "Es un proyecto único, desarrollado en colaboración con nuestros socios de Urban Estate, representa una alianza estratégica que da lugar a un emprendimiento excepcional, pensado para ofrecer lo mejor en cada detalle.",
        url: "/pics/cespedes/1.jpeg",
      },
      {
        title: "",
        body: "Este moderno desarrollo de 10 pisos ofrece espacios comunes pensados para tu bienestar, constituido por los amenities del edificio tales como piscina, solárium y zona de parrilla, aprovechando al máximo las visuales abiertas que brinda la esquina y su orientación Norte.",
        url: "/pics/cespedes/10.jpeg",
      },
      {
        title: "",
        body: "Vivir en un emprendimiento moderno en Belgrano es la oportunidad ideal para disfrutar de un estilo de vida que combina confort y conveniencia para toda la familia. Cada detalle está pensado para hacer tu día a día más placentero, en un entorno que ofrece la tranquilidad y el confort que mereces, sin renunciar a las ventajas de la vida urbana.",
        url: "/pics/cespedes/8.jpeg",
      },
    ],
    carousel: [
      "/pics/cespedes/1.jpeg",
      "/pics/cespedes/2.jpeg",
      "/pics/cespedes/3.jpeg",
      "/pics/cespedes/4.jpeg",
      "/pics/cespedes/5.jpeg",
      "/pics/cespedes/6.jpeg",
      "/pics/cespedes/7.jpeg",
      "/pics/cespedes/8.jpeg",
      "/pics/cespedes/9.jpeg",
      "/pics/cespedes/10.jpeg",
    ],
    map: {
      map: "/pics/palpa/map.webp",
      link: "https://www.google.com.ar/maps/place/C%C3%A9spedes+2518,+C1426DUJ+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.5698755,-58.4518527,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb5c4fc823d0d:0x246a70498e26d6f7!8m2!3d-34.5698755!4d-58.4492778!16s%2Fg%2F11h553t4pl?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
      title: "Belgrano - LIVE VOIR",
      location: "Céspedes 2518, CABA",
      body: "La comodidad y conectividad se encuentran en esta esquina privilegiada de Belgrano.<br/><br/>A tan solo unos pasos de la estación de tren Colegiales y a pocas cuadras de las estaciones de subte D, Olleros y José Hernández, tendrás acceso rápido y directo a las principales vías de transporte de la ciudad. Además, su cercanía a la Av. Cabildo te garantiza una excelente conexión con el resto de la ciudad, facilitando tus desplazamientos y acercándote a todos los servicios y comodidades que necesitas para vivir de manera plena y conveniente.",
      coords: [-34.56976062442709, -58.44926707478073, "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3285.3598352250915!2d-58.45184738882564!3d-34.56976057285361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDM0JzExLjEiUyA1OMKwMjYnNTcuNCJX!5e0!3m2!1ses-419!2sar!4v1743687312900!5m2!1ses-419!2sar"],
    },
    environment: {
      "3 Ambientes": {
        "2D": "/pics/cespedes/2D/3 Ambientes.png",
        surface: "64,80 m2",
        environments: 3,
        toilets: 1,
        bathrooms: 1,
        rooms: 2,
      },
      "3 Ambientes con 2 Balcones": {
        "2D": "/pics/cespedes/2D/3 Ambientes con 2 Balcones.png",
        surface: "76,86 m2",
        environments: 3,
        bathrooms: 1,
        toilets: 1,
        rooms: 2,
      },
      "Monoambiente Divisible": {
        "2D": "/pics/cespedes/2D/Monoambiente Divisible.png",
        surface: "40,87 m2",
        environments: 1,
        bathrooms: 1,
        rooms: 1,
      },
      "2 Ambientes Divisible": {
        "2D": "/pics/cespedes/2D/2 Ambientes Divisible.png",
        surface: "49,28 m2",
        environments: 2,
        bathrooms: 1,
        rooms: 1,
      },
      "2 Ambientes": {
        "2D": "/pics/cespedes/2D/2 Ambientes.png",
        surface: "56,01 m2",
        environments: 2,
        bathrooms: 1,
        rooms: 1,
      },
    },
  },
};
